<template>
  <v-row justify="center">
    <v-dialog v-model="dialogOrder" persistent max-width="900">
        <div class="printed">
            <v-card outlined style="overflow-y: auto;">
                <div class="d-flex flex-row-reverse">
                    <v-btn icon @click="setDialogOrder(false)">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-card-text class="pt-0">
                    <v-row>
                        <v-col cols="8" sm="4" md="8">
                            <h2 style="font-family: 'Arial'">Ringkasan Order</h2>
                            <h4 style="font-family: 'Arial'">#{{dataDetails.name}}</h4>
                        </v-col>
                        <v-col cols="4" sm="2" md="4">
                            <p class="font-weight-bold text-right mb-0">{{dataUser.company == undefined ? 'Tidak ada nama' : dataUser.company.name}}</p>
                            <p class="text-right mb-0">{{dataUser.company == undefined ? 'Tidak ada alamat' : dataUser.company.email}}</p>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="mt-4">
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Nama Customer:</p>
                        </v-col>
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="text-left">{{dataDetails.customer == null ? 'Tidak ada nama customer' : dataDetails.customer.name}}</p>
                        </v-col>
                        <v-col cols="4" sm="2" md="4" class="text-center pa-0">
                        <template v-if="dataDetails.status == 'PAID'">
                            <v-chip
                            class="mb-2"
                            color="green"
                            label
                            outlined
                            >
                            <v-icon left>monetization_on</v-icon>
                            {{dataDetails.status}}
                            </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'PARTIAL'">
                            <v-chip
                            class="mb-2"
                            color="blue"
                            label
                            outlined
                            >
                            <v-icon left>monetization_on</v-icon>
                            {{dataDetails.status}}
                            </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'APPROVED'">
                            <v-chip
                            class="mb-2"
                            color="orange"
                            label
                            outlined
                            >
                            <v-icon left>monetization_on</v-icon>
                            UNPAID
                            </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'REJECTED'">
                            <v-chip
                            class="mb-2"
                            color="red darken-2"
                            label
                            outlined
                            >
                            <v-icon left>cancel</v-icon>
                            {{dataDetails.status}}
                            </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'COMPLETED'">
                            <v-chip
                            class="mb-2"
                            color="green"
                            label
                            outlined
                            >
                            <v-icon left>check_box</v-icon>
                            {{dataDetails.status}}
                            </v-chip>
                        </template>
                        </v-col>
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Nama Cashier:</p>
                        </v-col>
                        <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                        <p class="text-right">{{dataDetails.user == null ? 'Tidak ada nama petugas' : dataDetails.user.name}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Telepon Customer:</p>
                        </v-col>
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="text-left">{{dataDetails.customer == null ? 'Tidak ada telepon customer' : dataDetails.customer.telp == null ? 'Tidak ada telepon customer' : dataDetails.customer.telp}}</p>
                        </v-col>
                        <v-col cols="4" sm="2" md="4" class="text-center">
                        </v-col>
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Order Number:</p>
                        </v-col>
                        <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                        <p class="text-right">{{dataDetails.id}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Tanggal Order:</p>
                        </v-col>
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="text-left">{{dataDetails.date}}</p>
                        </v-col>
                        <v-col cols="4" sm="2" md="4" class="text-center pa-0">
                            <QRCanvas :options="options" />
                            <div>
                                <v-btn icon @click="perbesarQRCode()" color="green">
                                    <v-icon>zoom_in</v-icon>
                                </v-btn> -
                                <v-btn icon @click="perkecilQRCode()" color="red">
                                    <v-icon>zoom_out</v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Jumlah Pesanan:</p>
                        </v-col>
                        <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                        <p class="text-right">{{dataDetails.items.length}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pa-0 pl-3" cols="12" sm="6" md="12">
                            <p class="font-weight-bold mb-0">Catatan:</p>
                            <p class="text-left">{{dataDetails.note == null ? 'Tidak ada catatan' : dataDetails.note}}</p>
                        </v-col>
                        <!-- <v-col class="pa-0 pl-3" cols="10" sm="5" md="10">
                        </v-col> -->
                    </v-row>
                    <v-simple-table fixed-header max-height="300px" class="mb-4">
                        <template>
                        <thead class="grey lighten-4">
                            <tr>
                            <td v-for="header in headerSubItem" :key="header.text" :class="header.align">{{ header.text }}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="subItem in dataDetails.items" :key="subItem.id">
                            <td class="text-left" v-if="subItem.schedule">
                                <b>{{ subItem.item_name }}</b> 
                                <!-- <v-btn icon @click="openDialogEdit(subItem)" color="orange">
                                    <v-icon small>edit</v-icon>
                                </v-btn> -->
                                <br/> Mulai: {{ subItem.schedule.start.substring(0, 16) }} 
                                <br/> Selesai: {{ subItem.schedule.finish.substring(0, 16) }} 
                            </td>
                            <td class="text-left" v-else>{{ subItem.item_name }}</td>
                            <td class="text-center" v-if="subItem.schedule">{{ Number(subItem.qty) % 1 == 0 ? Number(subItem.qty) : Number(subItem.qty).toFixed(2).replace(".00", "") }} Jam</td>
                            <td class="text-center" v-else>{{ Number(subItem.qty) % 1 == 0 ? Number(subItem.qty) : Number(subItem.qty).toFixed(2).replace(".00", "") }} Pcs</td>
                            <td class="text-center">{{ Number(subItem.harga_jual) }}</td>
                            <!-- <td class="text-center"><span class="green--text">{{ Number(subItem.discount) % 1 == 0 ? Number(subItem.discount) : (subItem.discount).toFixed(2).replace(".00", "") }}%</span></td> -->
                            <td class="text-center"><span class="orange--text">{{ Number(subItem.ppn) % 1 == 0 ? Number(subItem.ppn) : Number(subItem.ppn).toFixed(2).replace(".00", "") }}%</span></td>
                            <td class="text-right" v-if="subItem.discount!=0 && subItem.ppn!=0">
                                {{ Number(( (Number(subItem.qty)*(Number(subItem.harga_jual))) * (1-(Number(subItem.discount)/100)) ) * (1+(Number(subItem.ppn)/100))) % 1 == 0 ?
                                Number(( (Number(subItem.qty)*(Number(subItem.harga_jual))) * (1-(Number(subItem.discount)/100)) ) * (1+(Number(subItem.ppn)/100))) :
                                (( (Number(subItem.qty)*(Number(subItem.harga_jual))) * (1-(Number(subItem.discount)/100)) ) * (1+(Number(subItem.ppn)/100))).toFixed(4).replace(".0000", "") }}
                            </td>
                            <td class="text-right" v-else-if="subItem.discount!=0">
                                {{ Number(( (Number(subItem.qty)*(Number(subItem.harga_jual))) * (1-(Number(subItem.discount)/100)) )) % 1 == 0 ?
                                Number(( (Number(subItem.qty)*(Number(subItem.harga_jual))) * (1-(Number(subItem.discount)/100)) )) :
                                ((Number(subItem.qty)*(Number(subItem.harga_jual))) * (1-(Number(subItem.discount)/100))).toFixed(4).replace(".0000", "")}}
                            </td>
                            <td class="text-right" v-else-if="subItem.ppn!=0">
                                {{ Number(( (Number(subItem.qty)*(Number(subItem.harga_jual))) * (1+(Number(subItem.ppn)/100)) )) % 1 == 0 ? 
                                Number(( (Number(subItem.qty)*(Number(subItem.harga_jual))) * (1+(Number(subItem.ppn)/100)) )) : 
                                ((Number(subItem.qty)*(Number(subItem.harga_jual))) * (1+(Number(subItem.ppn)/100))).toFixed(4).replace(".0000", "")}}
                            </td>
                            <td class="text-right" v-else>
                                {{ (Number(subItem.qty)*(Number(subItem.harga_jual))) % 1 == 0 ? 
                                (Number(subItem.qty)*(Number(subItem.harga_jual))) : 
                                (Number(subItem.qty)*(Number(subItem.harga_jual))).toFixed(4).replace(".0000", "") }}
                            </td>
                            </tr>
                            <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td><h4 class="text-right font-weight-bold">Subtotal:</h4></td>
                            <td class="text-right">{{ Number(dataDetails.total) }}</td>
                            </tr>
                            <tr v-if="paid > 0">
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td><h4 class="text-right font-weight-bold green--text">Dibayar:</h4></td>
                            <td class="text-right green--text">{{ Number(paid) }}</td>
                            </tr>
                            <tr>
                            <td colspan="3">
                                <!-- <v-btn
                                    class="ma-2"
                                    small
                                    color="primary"
                                    @click="expand = !expand"
                                >
                                <v-icon class="mr-2">history</v-icon> Riwayat Pembayaran
                                </v-btn> -->
                                <!-- <v-btn
                                    v-if="role == 'cashier' && dataDetails.status == 'PAID'"
                                    class="ma-2"
                                    small
                                    color="success"
                                    @click="completeSubmission()"
                                >
                                <v-icon class="mr-2">done</v-icon> Order Selesai
                                </v-btn> -->
                                <v-btn
                                    small
                                    class="white--text"
                                    style="margin: 10px"
                                    color="teal"
                                    @click="onPrint()"
                                >
                                    <v-icon class="mr-2">print</v-icon>
                                    PRINT
                                </v-btn>
                                <v-btn
                                    small
                                    class="white--text"
                                    style="margin: 10px"
                                    color="green"
                                    @click="setDialogOrder(false)"
                                >
                                    <v-icon class="mr-2">replay</v-icon>
                                    PESAN LAGI
                                </v-btn>
                                <v-btn
                                    small
                                    class="white--text"
                                    style="margin: 10px"
                                    color="red"
                                    @click="logOut()"
                                >
                                    <v-icon class="mr-2">done</v-icon>
                                    PESANAN SELESAI
                                </v-btn>
                            </td>
                            <td v-if="dataDetails.total - paid > 0 && paid > 0"><h4 class=" text-right font-weight-bold">Total:</h4></td>
                            <td v-if="dataDetails.total - paid > 0 && paid > 0" class="text-right">{{ dataDetails.total - paid }}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                    <v-expand-transition>
                        <v-card
                            v-show="expand"
                            outlined
                        >
                        <p class="text-center font-weight-bold" style="margin: 30px 0px">RIWAYAT PEMBAYARAN</p>
                            <v-simple-table fixed-header>
                                <template>
                                <thead class="grey lighten-4">
                                    <tr>
                                    <td v-for="header in headerPaymentHistory" :key="header.text">{{ header.text }}</td>
                                    </tr>
                                </thead>
                                <tbody v-if=" paymentItems != null">
                                    <tr v-for="subItem in paymentItems" :key="subItem.id">
                                    <!-- <td>{{ new Date(subItem.tanggal).toLocaleDateString('id') }}</td> -->
                                    <td>{{ subItem.tanggal }}</td>
                                    <td>{{ Number(subItem.jumlah) }}</td>
                                    <td>{{ subItem.payment_methods ? subItem.payment_methods.name : '-' }}</td>
                                    <td>
                                        <v-icon v-if="dataDetails.status != 'COMPLETED'" small class="mr-2" @click="deletePayment(subItem)">delete</v-icon>
                                        <p v-else>-</p>
                                    </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                    <td colspan="4"><p class="font-weight-bold">No data available.</p></td>
                                    </tr>
                                    <!-- <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><p class="font-weight-bold">Total</p></td>
                                    <td><p>{{ dataDetails.total }}</p></td>
                                    </tr> -->
                                </tbody>
                                <v-btn
                                    v-if="Number(dataDetails.total) > paid && (dataDetails.status == 'APPROVED' || dataDetails.status == 'PARTIAL')"
                                    small
                                    class="white--text"
                                    style="margin: 10px"
                                    color="green"
                                    @click="[setDialogPayment(true), this.jumlahPayment = (Number(dataDetails.total) - paid)]"
                                >
                                    <v-icon >add</v-icon>
                                    TAMBAH PEMBAYARAN
                                </v-btn>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-expand-transition>
                </v-card-text>
            </v-card>
        </div>
    </v-dialog>

    <v-dialog
        v-model="dialogPayment"
        max-width="500px"
        persistent
    >
        <v-card>
            <v-card-title>
                Tambah Pembayaran
            </v-card-title>
            <v-card-text>
                <!-- <v-text-field type="datetime-local" v-model="paymentDate" label="Tanggal" required></v-text-field> -->
                <v-text-field type="number" required v-model="jumlahPaymentModel" label="Jumlah"></v-text-field>
                <v-select v-model="paymentMethodSelected" :items="paymentMethod" label="Metode Pembayaran" required></v-select>
                <p class="font-italic red--text" v-show="showError">*Jumlah pembayaran tidak boleh melebihi jumlah tagihan!</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closePayment()">Cancel</v-btn>
                <v-btn v-if="paymentMethodSelected != ''" color="blue darken-1" text @click="savePayment()">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" max-width="500">
        <v-card>
          <v-container>
            <v-form @submit.prevent="editItem">
              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="6">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="inputStart"
                        label="Tanggal Mulai"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="inputStart" @change="[onCekJadwal(), inputEnd = inputStart]" @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select :items="jamItemsStart" v-model="startJam" @change="onCekJadwal" label="Jam"></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-menu
                    v-model="menuFinish"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="inputEnd"
                        label="Tanggal Selesai"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="inputEnd" @change="onCekJadwal" @input="menuFinish = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select :items="jamItemsFinish" v-model="finishJam" @change="onCekJadwal" label="Jam"></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" v-if="jasaItems.length > 0 && availableStock">
                  <v-select prepend-icon="add_shopping_cart" :items="jasaItems" v-model="selectedJasa" label="Jasa & Layanan"></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" v-if="jasaItems.length == 0">
                  <p class="font-italic red--text caption">*Tidak ditemukan, silahkan cari jadwal lain.</p>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" v-if="jasaItems.length > 0 && !availableStock">
                  <p class="font-italic red--text caption">*Durasi waktu harus sama dengan data sebelumnya.</p>
                </v-col>
              </v-row>
              <v-btn type="submit" color="primary" v-if="jasaItems.length > 0 && selectedJasa && availableStock" class="mr-4">
                Save
              </v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>
  </v-row>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isEmpty, remove, find } from "lodash";
import { QRCanvas } from 'qrcanvas-vue';
import moment from 'moment';
export default {
  name: "DialogOrder",
  components: {
      QRCanvas,
  },
  data: () => ({
      total: 0,
      role: null,
      valid: true,
      headerSubItem: [
          { text: "Nama Item", align: 'text-left'},
          { text: "Jumlah", align: 'text-center'},
          { text: "Harga", align: 'text-center'},
          // { text: "Diskon", align: 'text-center'},
          { text: "PPN", align: 'text-center'},
          { text: "Total Harga", align: 'text-right'}
      ],
      headerPaymentHistory: [
          { text: "Tanggal"},
          { text: "Jumlah"},
          { text: "Metode Pembayaran",  align: 'text-right'},
          { text: "Delete",  align: 'text-right'},
      ],
      paymentMethod: [],
      paymentMethodSelected: "",
      paymentDate: "",
      expand: false,
      showError: false,
      cell: 4,
      dataQR: 'Order',
      menu: false,
      menuFinish: false,
      jamItemsStart: [],
      jamItemsFinish: [],
      startJam: null,
      finishJam: null,
      inputStart: null,
      inputEnd: null,
      start: null,
      end: null,
      selectedJasa: null,
      jasaItems: [],
      available: [],
      dialogEdit: false,
      selectedItem: {},
      availableStock: false
  }),
  computed: {
      ...mapState({
          dialogOrder: state => state.pesanan.dialogOrder,
          idDialogOrder: state => state.pesanan.idDialogOrder,
          dataUser: state => state.pesanan.dataUser,
          dataDetails: state => state.pesanan.dataDetails,
          paymentItems: state => state.pesanan.paymentItems,
          paid: state => state.pesanan.paid,
          allProductJasa: state => state.jadwal.allProductJasa,
          productJasa: state => state.jadwal.productJasa,
          dialogPayment: state => state.pesanan.dialogPayment,
          jumlahPayment: state => state.pesanan.jumlahPayment
      }),
      options() {
          return {
              cellSize: this.cell,
              correctLevel: 'M',
              data: this.dataQR,
          };
      },
      jumlahPaymentModel: {
        get () {
          return this.jumlahPayment
        },
        set (newValue) {
          this.setJumlahPayment(newValue)
        }
      },
      dataCustomer: {
          get () {
              return this.$store.state.pesanan.selectedCustomer
          },
          set (value) {
              this.setCustomer(value)
          }
      },
      userFound: {
          get () {
              return this.$store.state.pesanan.userFound
          },
          set (value) {
              this.setUserFound(value)
          }
      },
      inputSearch: {
          get () {
              return this.$store.state.pesanan.inputSearch
          },
          set (value) {
              this.setInputSearch(value)
          }
      }
  },
  mounted() {
    this.initialize()
  },

  methods: {
    ...mapMutations({
      showSnackbar: "showSnackbar",
      showLoading: "showLoading",
      closeLoading: "closeLoading",
      setDialogOrder: "pesanan/SET_DIALOG_ORDER",
      setIdDialogOrder: "pesanan/SET_ID_DIALOG_ORDER",
      setDataDetails: "pesanan/SET_DATA_DETAILS",
  		setPaymentItems: "pesanan/SET_PAYMENT_ITEMS",
      setPaid: "pesanan/SET_PAID",
      setListOrder : "pesanan/SET_LIST_ORDER",
      setDialogPayment : "pesanan/SET_DIALOG_PAYMENT",
      setJumlahPayment : "pesanan/SET_JUMLAH_PAYMENT",
      setCustomer: "pesanan/SET_CUSTOMER",
      setUserFound: "pesanan/SET_USER_FOUND",
      setInputSearch: "pesanan/SET_INPUT_SEARCH",
    }),
    ...mapActions({
      updateStatusPesanan: "pesanan/updateStatusPesanan",
      detailOrder: "pesanan/detailOrder",
      getTransaction: "transaction/getTransactionBySubmissionId",
      createTransaction: "transaction/createTransaction",
      deleteTransaction: "transaction/deleteTransaction",
      getPesanans: "pesanan/getPesanans",
      getProductJasa: "jadwal/getProductJasa",
      getProductJasaEdit: "jadwal/getProductJasaEdit",
      cekJadwal: "jadwal/cekJadwal",
      updateItem: "products/updateItem",
      updateJadwal: "jadwal/updateJadwal",
      getPaymentMethods: "payment_methods/getPaymentMethods",
      resetPesanan: "products/resetPesanan"
    }),
    async initialize(){
      this.role = window.localStorage.getItem('user_role')
      this.dataQR = 'SUBMISSION_ID:' + this.idDialogOrder + ';TYPE:ORDER';
      for (let i = 0; i < 24; i++) {
          this.jamItemsStart.push({
              text: i.toString().length == 1 ? '0' + i + ':00' : i + ':00',
              value: i.toString().length == 1 ? '0' + i + ':00:01' : i + ':00:01'
          })

          this.jamItemsFinish.push({
              text: i.toString().length == 1 ? '0' + i + ':00' : i + ':00',
              value: i.toString().length == 1 ? (i === 0 ? '23:59:00' : '0' + i + ':00:01') : i + ':00:00'
          })
      }

      const paymentMethodResponse = await this.getPaymentMethods()

      this.paymentMethod = []
      forEach(paymentMethodResponse.data.attributes, (payment, i) => {
          this.paymentMethod.push({
              text: payment.name,
              value: payment.id
          })
      })
    },
    logOut(){
      window.localStorage.removeItem('dataCustomer')
      window.localStorage.removeItem('userFound')
      window.localStorage.removeItem('inputSearch')
      this.dataCustomer = null
      this.userFound = false
      this.inputSearch = null
      this.resetPesanan()
      this.setDialogOrder(false)
      this.$router.push('/dashboard')
    },
    openDialogEdit(item){
      this.dialogEdit = true
      this.selectedItem = item
    },
    onPrint(){
        // this.setDialogOrder(false)
        // let routeData = this.$router.push('print')
        // console.log('routeData.href', routeData.href)
        window.open('print/'+this.idDialogOrder, '_blank')
    },
    async savePayment(){
      if(this.jumlahPayment <= (Number(this.dataDetails.total) - this.paid)){
        const payload = {
          "submission_id": this.dataDetails.id,
          "payment_method_id": this.paymentMethodSelected,
          "tanggal": moment().format('YYYY-MM-DD HH:mm:ss'),
          "jumlah": this.jumlahPayment
        }

        if(this.dataDetails.total == (Number(this.paid)+Number(this.jumlahPayment))){
          const payloadUpdate = {
            "id": this.dataDetails.id,
            "status": 'PAID',
            "data": this.dataDetails
          }
          const responseUpdate = await this.updateStatusPesanan(payloadUpdate)
          if(responseUpdate.data.success){
            this.showSnackbar({ text: 'Pembayaran telah dilunasi', color: 'green', timeout: 1500 })
          }
        }else{
          const payloadUpdate = {
            "id": this.dataDetails.id,
            "status": 'PARTIAL',
            "data": this.dataDetails
          }

          const responseUpdate = await this.updateStatusPesanan(payloadUpdate)
          if(responseUpdate.data.success){
            this.showSnackbar({ text: 'Sebagian pembayaran telah dilunasi', color: 'green', timeout: 1500 })
          }
        }

        const response = await this.createTransaction(payload)

        if(response.data.success){
          this.setIdDialogOrder(this.dataDetails.id)
          this.detailOrder()
          const responseOrder = await this.getPesanans()
          let item_order = []

          if(responseOrder.status == 200){
              forEach(responseOrder.data, data => {
                  data.total = Number(data.total)
                  item_order.push(data)
              })

              this.setListOrder(item_order)
          }else{
              this.showSnackbar({ text: 'Error get data', color: 'red', timeout: 1500 })
          }
          this.paymentMethodSelected = ""
          this.paymentDate = ""
          this.jumlahPayment = 0
          this.closePayment()
          this.showSnackbar({ text: 'Data pembayaran berhasil disimpan', color: 'green', timeout: 1500 })
          this.setDialogOrder(true)
        }else{
          alert('Network Error!')
        }
      }else{
        this.showError = true
      }
    },
    async deletePayment(item){
      if((Number(this.paid)-Number(item.jumlah)) < 1){
        const payloadUpdate = {
          "id": this.dataDetails.id,
          "status": 'APPROVED',
          "data": this.dataDetails
        }
        const responseUpdate = await this.updateStatusPesanan(payloadUpdate)
        if(responseUpdate.data.success){
            this.showSnackbar({ text: 'Update pembayaran berhasil dilakukan', color: 'green', timeout: 1500 })
        }
      }else{
        const payloadUpdate = {
          "id": this.dataDetails.id,
          "status": 'PARTIAL',
          "data": this.dataDetails
        }
        const responseUpdate = await this.updateStatusPesanan(payloadUpdate)
        if(responseUpdate.data.success){
            this.showSnackbar({ text: 'Update pembayaran berhasil dilakukan', color: 'green', timeout: 1500 })
        }
      }

      const response = await this.deleteTransaction(item.id)
      if(response.data.success){
          this.setIdDialogOrder(this.dataDetails.id)
          this.detailOrder()
          const responseOrder = await this.getPesanans()
          let item_order = []

          if(responseOrder.status == 200){
              forEach(responseOrder.data, data => {
                  data.total = Number(data.total)
                  item_order.push(data)
              })

              this.setListOrder(item_order)
          }else{
              this.showSnackbar({ text: 'Error get data', color: 'red', timeout: 1500 })
          }
          this.showSnackbar({ text: 'Data pembayaran berhasil dihapus', color: 'green', timeout: 1500 })
      }else{
        alert('Network Error!')
      }
    },
    async completeSubmission(){
        const payloadUpdate = {
            "id": this.dataDetails.id,
            "status": 'COMPLETED',
            "data": this.dataDetails
        }

        const response = await this.updateStatusPesanan(payloadUpdate)
        if(response.data.success){
            this.setIdDialogOrder(this.dataDetails.id)
            this.detailOrder()
            const responseOrder = await this.getPesanans()
            let item_order = []

            if(responseOrder.status == 200){
                forEach(responseOrder.data, data => {
                    data.total = Number(data.total)
                    item_order.push(data)
                })

                this.setListOrder(item_order)
            }else{
                this.showSnackbar({ text: 'Error get data', color: 'red', timeout: 1500 })
            }
    
            this.showSnackbar({ text: 'Order telah selesai', color: 'green', timeout: 1500 })
        }
    },
    closePayment(){
        this.showError = false
        this.setDialogPayment(false)
        this.setDialogOrder(true)
    },
    perbesarQRCode(){
        if(this.cell < 12){
            this.cell = this.cell + 4 
        } 
    },
    perkecilQRCode(){
        if(this.cell > 4){
            this.cell = this.cell - 4 
        }
    },
    async onCekJadwal(){
        let d1 = new Date(this.inputStart + " " + this.startJam.replace(":01", ":00"));
        let d2 = new Date(this.inputEnd + " " + this.finishJam);
        let greaterThanDate = d1.getTime() > d2.getTime();

        if(!greaterThanDate){
          this.availableStock = false
          this.getProductJasaEdit(this.selectedItem)
          this.jasaItems = []
          let available = this.productJasa
          if (this.inputStart && this.inputEnd && this.startJam && this.finishJam && (this.inputStart + " " + this.startJam.replace(":01", ":00") != this.inputEnd + " " + this.finishJam)) {
            const payload = {
                from: this.inputStart + " " + this.startJam,
                to: this.inputEnd + " " + this.finishJam
            }
            const response = await this.cekJadwal(payload)

            forEach(response.data.attributes, data => {
              remove(available, function(currentObject) {
                  return currentObject.value === data.product_id;
              });
            })

            forEach(available, ava => {
              this.jasaItems.push(ava)
            })
          } 

          const start = new Date(this.inputStart+' '+this.startJam)
          const end = new Date(this.inputEnd+' '+this.finishJam)

          if((end - start + 1000)/3600000 == Number(this.selectedItem.qty)){
              this.availableStock = true
          }
        }else{
          this.jasaItems = []
        }
    },
    async editItem () {
        const selectedProduct = find(this.allProductJasa, jasa => jasa.id == this.selectedJasa)

        const start = new Date(this.inputStart+' '+this.startJam)
        const end = new Date(this.inputEnd+' '+this.finishJam)

        const itemPesanan = {
            id: this.selectedItem.id,
            product_id: selectedProduct.id,
            item_name: selectedProduct.name,
            mulai: this.inputStart+' '+this.startJam,
            selesai: this.inputEnd+' '+this.finishJam
        }

        const responseItem = await this.updateItem(itemPesanan)

        const payloadJadwal = {
            id: this.selectedItem.schedule.id,
            product_id: selectedProduct.id,
            start: this.inputStart+' '+this.startJam,
            finish: this.inputEnd+' '+this.finishJam
        }
        const responseJadwal = await this.updateJadwal(payloadJadwal)

        this.dialogEdit = false
        this.inputStart = null
        this.inputEnd = null
        this.startJam = null
        this.finishJam = null
        this.selectedJasa = null
        this.availableStock = false
        this.jasaItems = []

        if(responseItem.data.success && responseJadwal.data.success){
            this.setIdDialogOrder(this.dataDetails.id)
            this.detailOrder()
        }else{
            window.reload()
        }
    }
  }
};
</script>
<style>
@media print {
  body * {
    background: white!important;
  }
}
</style>